import React from 'react';
import { Text } from 'rebass/styled-components';
import { IBuilderCtrlViewProps } from '../types';

export const LabelCtrl : React.FC<IBuilderCtrlViewProps>= ({ properties }) => {
  return (
    <>
      <Text fontWeight={500}>{`${(properties || {}).question || 'Section'}`}</Text>
    </>
  );
};
